import React, { useState } from 'react';
import { useQuery } from 'react-query';
import axios from '../../../utils/AxiosUtil';
import { Select, Spin } from 'antd';

let { Option } = Select;

export function ProvinceSelect(props) {
    let { isLoading, isSuccess, isError, data, error } = useQuery('provinceList', () => axios.post('/fund/area/list-province'), { refetchOnWindowFocus: false });
    if (isLoading) {
        return <Spin tip="加载中..." />
    } else if (isError) {
        return <div>加载错误：{error}</div>
    } else {
        let provinceList = data ?.data ?.data;
        // console.log("加载成功provinceList:", provinceList);

        return <Select defaultValue={props.defaultProvince}
            onChange={(value) => props.handleProvinceChange(value)} style={{ width: '100%' }}>
            {provinceList.map((p, i) => {
                return <Option value={p.province} key={i}>{p.province}</Option>
            })}
        </Select>
    }
}

export function CitySelect(props) {
    const { selectedProvince } = props;
    if (selectedProvince) {
        const { isLoading, isSuccess, isError, data, error } = useQuery(['ListCityByProvince', selectedProvince],
            () => axios.post('/fund/area/list-city-by-province', { province: selectedProvince })
                .catch(e => console.log("ListCityByProvince error:", e)),
            { refetchOnWindowFocus: false });
        if (isLoading) {
            return <Spin tip="加载中..." />
        } else if (isError) {
            return <div>加载错误：{error}</div>
        } else {
            let cityList = data ?.data ?.data;
            // console.log('cityList:', cityList);
            return (
                <Select defaultValue={props.defaultCity}
                    onChange={(value) => props.handleCityChange(value)} style={{ width: '100%' }}>
                    <Option value=''>（不选）</Option>
                    {cityList ?.map((c, i) => {
                        return <Option value={c.city} key={i}>{c.city}</Option>
                    })}
                </Select >)
        }
    } else {
        return <Select disabled placeholder="请先选择省" />
    }

}